var map = {
	"./AJINOMOTO.png": 2439,
	"./APSEN.png": 7340,
	"./BRF.png": 9121,
	"./CAMPNEUS.png": 3835,
	"./CELLERAFARMA.png": 1232,
	"./COSAN.png": 1947,
	"./DUASRODAS.png": 8303,
	"./FARMAX.png": 8204,
	"./GLOBOSAT.png": 2704,
	"./GREE.png": 2534,
	"./HINODE.png": 8882,
	"./INGLEZA.png": 3921,
	"./LASTLINK.png": 5243,
	"./LEAO.png": 4994,
	"./LENOVO.png": 3758,
	"./MATTEL.png": 6994,
	"./MDS.png": 2009,
	"./MEDQUIMICA.png": 228,
	"./MOOVE.png": 3759,
	"./NAGEM.png": 5867,
	"./NOTREDAME.png": 7252,
	"./SCALA.png": 2201,
	"./SKY.png": 780,
	"./THERASKIN.png": 4570,
	"./UNIMED.png": 2515,
	"./UNIVERSAL.png": 416,
	"./VETBR.png": 6402,
	"./WARNER.png": 3298,
	"./WICKBOLD.png": 4084,
	"./ZOETIS.png": 3089,
	"./logos": 6132,
	"./logos.json": 6132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7571;